<template>
    <v-container fluid>
        <v-row
                align="center"
                justify="center"
        >
            <v-col
                    cols="12"
                    sm="6"
            >
                <v-card
                        width="400px"
                        class="mx-auto elevation-7">
                    <v-toolbar
                        class="mb-5"
                        dark
                        flat
                        color="primary"
                    >
                        <v-toolbar-title>
                            {{$t('messageLogin')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-img
                            class="ml-4 mr-4"
                            :src="require('../assets/logo_escuela.png')"
                            height="250px"
                            contain
                    >
                    </v-img>
                    <v-card-text>
                        <v-form class="mb-4"
                                @submit.prevent="login()"
                        >
                            <v-text-field
                                    autofocus
                                    v-model="correo"
                                    name="correo"
                                    prepend-icon="mdi-email"
                                    label="E-Mail"
                                    :error-messages="errores.email"
                            ></v-text-field>
                            <v-text-field
                                    v-model="password"
                                    name="password"
                                    prepend-icon="mdi-lock"
                                    :label="$t('lblPassword')"
                                    :type="show ? 'text' : 'password'"
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                    :error-messages="errores.password"
                                    @click:append="show = !show"
                            ></v-text-field>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                {{errores.non_field_errors}}
                            </v-alert>
                            <v-card-actions>
                                <v-flex>
                                    <span>{{$t('msgOlvidarPassword')}}</span>
                                    <br>
                                    <span>
                                    {{$t('msgLinkRestablecer1')}}
                                        <router-link :to="{ name: 'password_reset'}">
                                            {{$t('msgLinkRestablecer2')}}
                                        </router-link>
                                    {{$t('msgLinkRestablecer3')}}
                                </span>
                                </v-flex>
                            </v-card-actions>
                            <v-btn
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >
                                {{$t('btnLogin')}}
                            </v-btn>
                            <br>
                            <br>
                            <v-btn
                                    to="/signup_tutor"
                                    block
                                    color="primary"
                            >
                                {{$t('btnRegistrarTutores')}}
                                <v-icon right dark>mdi-account-edit</v-icon>
                            </v-btn>
                            <br>
                            <v-btn
                                    to="/signup_guest"
                                    block
                                    color="secondary"
                            >
                                {{$t('btnTeacher')}}
                                <v-icon right dark>mdi-human-male-board</v-icon>
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import { AUTH_REQUEST } from '../store/actions/auth'
import { USER_REQUEST } from '../store/actions/user'
import {HTTP} from '@/main.js'

export default {
    name: "Login",
    data: () => ({
        errores: [],
        show: false,
        correo: '',
        password: '',
        alerta: false,
        loading: false,
        // listaEstudiantesLocal: []
    }),
    computed: {
      ...mapState(['language']),
      ...mapGetters(['isAuthenticated', 'getProfile'])
    },
    beforeMount() {
      this.$options.sockets = {
        onmessage: data => this.messageReceived(data)
      }
    },
    methods: {
        messageReceived(data) {
          // console.log(JSON.parse(data.data))
          console.log('Parseados ', JSON.parse(data.data).message)
          // let type = JSON.parse(JSON.parse(data.data).message)
          // if(this.getProfile.role === 2) { //Si es Vigilante
          //   if (type.classification) {
          //   let qr_code = type.data
          //   switch (type.classification) {
          //     case 'qr':
          //       console.log('QR Code')
          //       if (qr_code !== '') {
          //         HTTP.get('student/access_code/' + qr_code, {
          //           headers: {
          //             'Content-Type': 'application/json',
          //             'authorization': 'Token ' + localStorage.getItem('user-token')
          //           }
          //         })
          //             .then(response => {
          //               // console.log(this.info_invitation.students[0].avatar)
          //               var item = response.data
          //               var studentfiltered = this.deleteStudentNoAttendance(item.available_students)
          //               item.available_students = studentfiltered
          //               this.sendNotificationToTeachers(item)
          //               var fullItem = Object.assign(item, {"qrCode": qr_code})
          //               console.log(fullItem)
          //               if(item.available_students.length > 0) {
          //                 this.addListItem(fullItem)
          //                 localStorage.setItem('listaEstudiantes',  JSON.stringify(this.listaEstudiantesLocal))
          //                 this.$socket.send(JSON.stringify( {
          //                   "message": JSON.stringify(this.listaEstudiantesLocal)
          //                 }))
          //               }
          //             })
          //             .catch(error => {
          //               console.log(error)
          //               // if (error.response.status === 404) {
          //               //   this.errorsGuard = this.$t('msg_qr_no_valido')
          //               //   this.head_color = 'red display-1 text--primary'
          //               //   this.dialogErrors = true
          //               //   this.activar_camara = false
          //               // }
          //               // if (error.response.status === 403) {
          //               //   this.errorsGuard = error.response.data.detail
          //               //   this.head_color = 'red display-1 text--primary'
          //               //   this.dialogErrors = true
          //               //   this.activar_camara = false
          //               // }
          //             })
          //       }
          //     break
          //   }
          //  } else {
          //   localStorage.setItem('listaEstudiantes', JSON.parse(data.data).message)
          //   this.$store.commit('setStudentsList', JSON.parse(data.data).message)
          //   }
          // }
          // else
          if (this.getProfile.role === 6){ //Si es Maestro(a)
           let datos = JSON.parse(JSON.parse(data.data).message)
           console.log('Datos = ', datos)
           this.$snotify.confirm(datos.body + ', ' + datos.classroom + '. Salida por: ' + datos.guardhouse_name, '', {
             timeout: 0,
             closeOnClick: false,
             type: 'info',
             newOnTop: true,
             buttons: [
               {
                 text: this.$t('sign'),
                 action: (toast) => {
                   this.$snotify.remove(toast.id);
                   this.signExitPass(datos.uuidStudent, datos.uuidClassroom);
                 },
                 bold: false
               }
             ]
           })
          }
        },
        login () {
            this.loading = true
            this.$store.dispatch(AUTH_REQUEST, { email: this.correo, password: this.password, language: this.language })
                .then(ok => {
                  this.loading = false
                  console.log('Hola01 = ', ok)
                  this.$store.dispatch(USER_REQUEST).then( ok => {
                    if (localStorage.getItem('pathValidationUser') !== null) {
                      this.$router.push({ path: localStorage.getItem('pathValidationUser') })
                      localStorage.removeItem('pathValidationUser')
                    } else {
                      this.$router.push({ name: 'home' })
                    }
                    console.log(ok)
                    console.log('Conecta....')
                    console.log('Data User  2 = ', this.getProfile.id)
                    switch (this.getProfile.role) {
                      case 4: //Administrador
                        this.$connect('wss://escuela-service.intrare.app/ws/websocket/' + this.getProfile.idSchool + '/?token=' +  localStorage.getItem('user-token'))
                      break;
                      case 6: //Maestro(a)
                        this.$connect('wss://escuela-service.intrare.app/ws/websocket/' + this.getProfile.id + '/?token=' +  localStorage.getItem('user-token'))
                      break;
                    }
                    console.log('Conectado')
                  })
                })
                .catch(error => {
                    // console.log(error.response.data['non_field_errors'])
                    // if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
                    this.errores = error.response.data
                    this.loading = false
                    if (error.response.data['non_field_errors'] != null) {
                        this.alerta = true
                        setTimeout(this.clear, 2000)
                        this.loading = false
                    }
                    // }
                })
        },
        clear () {
            this.alerta = false
            this.errores = []
            // this.$validator.reset()
        },
        signExitPass(uuidStudent, uuidClassroom) {
          var student = []

          student.push({
            'idStudent': uuidStudent
          })
          HTTP.patch('classroom/' + uuidClassroom + '/list/sign_pass/',
              student,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                  'authorization': 'Token ' + localStorage.getItem('user-token')
                }
              })
              .then(ok => {
                console.log(ok)
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_message', this.$t('sign_pass_success'))
                setTimeout(this.clearSnackBar, 3000)
              })
              .catch(error => {
                console.log(error)
              })
        },
        // addListItem(item) {
        //   let band = false
        //
        //   for(let i = 0 ; !band && i < this.listaEstudiantesLocal.length; i++) {
        //     console.log(this.listaEstudiantesLocal[i].qrCode, '===', item.qrCode)
        //     if(this.listaEstudiantesLocal[i].qrCode === item.qrCode){
        //       band = true
        //     }
        //   }
        //   if (!band) {
        //     this.listaEstudiantesLocal.push(item)
        //   }
        //   console.log(this.listaEstudiantesLocal)
        // },
        // deleteStudentNoAttendance(item) {
        //   let res = []
        //   console.log(item)
        //   for (let i=0; i < item.length; i++) {
        //     if(item[i].status !== -1) {
        //       console.log(item[i].status)
        //       res.push(item[i])
        //     }
        //   }
        //   return res
        // },
        // sendNotificationToTeachers (data) {
        //   for(let i = 0; i < data.available_students.length; i++) {
        //     if (data.available_students[i].status !== -1) {
        //       HTTP.post('student/' + data.available_students[i].id + '/exit/notification/', {}, {
        //         headers: {
        //           'Content-Type': 'application/json',
        //           'Accept-Language': this.language,
        //           'authorization': 'Token ' + localStorage.getItem('user-token')
        //         }
        //       })
        //       .then(ok => {
        //         console.log(ok)
        //       })
        //       .catch(error => {
        //         console.log(error)
        //       })
        //     }
        //   }
        // },
        clearSnackBar () {
          this.$store.commit('snackbar_change_color', 'success')
          this.$store.commit('snackbar_activate_false')
        }
    }
}
</script>

<style scoped>

</style>
